/** Latin + Cyrillic (U+0400–U+04FF), digits, _ - ; 1–128 chars; no / \ . space */
export const BUILD_ID_PATTERN = '^[a-zA-Z0-9_\\-\\u0400-\\u04FF]{1,128}$';
export const BUILD_ID_REGEX = /^[a-zA-Z0-9_\-\u0400-\u04FF]{1,128}$/;

export function isValidBuildId(value: string): boolean {
	return BUILD_ID_REGEX.test(value);
}

export const BUILD_ID_ERROR_MESSAGE =
	'Только буквы (латиница или кириллица), цифры, _ и -, от 1 до 128 символов';
